import type { AgBarSeriesOptions } from 'ag-charts-enterprise';
import dayjs from 'dayjs';

import type { SearchableSelectConfig } from '@/components/SearchableSelect';
import PERMISSIONS from '@/constants/auth.constants';
import { MONTH_DATE_FORMAT } from '@/constants/date.constants';

export const STATUS_LIST = [
  {
    label: 'Unknown',
    value: 'Unknown',
    id: 1
  },
  {
    label: 'Operational',
    value: 'Operational',
    id: 2
  },
  {
    label: 'Warning',
    value: 'Warning',
    id: 3
  },
  {
    label: 'Active',
    value: 'Active',
    id: 4
  },
  {
    label: 'Error',
    value: 'Error',
    id: 5
  },
  {
    label: 'New',
    value: 'New',
    id: 6
  },
  {
    label: 'Disabled',
    value: 'Disabled',
    id: 7
  },
  {
    label: 'Job Failed',
    value: 'Job Failed',
    id: 8
  },
  {
    label: 'Category Failed',
    value: 'Category Failed',
    id: 9
  },
  {
    label: 'Pending Restart',
    value: 'Pending Restart',
    id: 10
  }
];

const DEVICE_QUICK_FILTERS: SearchableSelectConfig[] = [
  {
    field: 'device_type_id',
    title: 'Type',
    config: {
      searchable: true,
      showCounts: true,
      variant: 'dropdown'
    },
    filterOptions: []
  },
  {
    field: 'status',
    title: 'Status',
    config: {
      searchable: true,
      showCounts: true,
      variant: 'dropdown'
    },
    filterOptions: []
  },
  {
    field: 'sources',
    title: 'Source',
    config: {
      searchable: true,
      showCounts: true,
      variant: 'dropdown'
    },
    filterOptions: []
  },
  {
    field: 'action',
    title: 'Action',
    config: {
      searchable: false,
      showCounts: true,
      variant: 'buttongroup'
    },
    filterOptions: []
  }
];

export default DEVICE_QUICK_FILTERS;

export const LIMA_SOURCE_QUICK_FILTERS: SearchableSelectConfig[] = [
  {
    field: 'source_type_id',
    title: 'Source',
    config: {
      searchable: true,
      showCounts: true,
      variant: 'dropdown'
    },
    filterOptions: []
  },
  {
    field: 'status',
    title: 'Status',
    config: {
      searchable: true,
      showCounts: true,
      variant: 'dropdown'
    },
    filterOptions: []
  },
  {
    field: 'active_state',
    title: 'ActiveStatus',
    config: {
      searchable: false,
      showCounts: false,
      variant: 'buttongroup'
    },
    filterOptions: [
      {
        label: 'Active',
        value: 'Active',
        id: 1
      },
      {
        label: 'Inactive',
        value: 'Inactive',
        id: 2
      }
    ]
  }
];

export enum DEVICE_STATUS {
  DEVICE_ACTIVATED = 'Device Activated',
  NEW = 'New',
  DISABLED = 'Disabled',
  UNKNOWN = 'Unknown',
  OPERATIONAL = 'Operational',
  WARNING = 'Warning',
  ERROR = 'Error',
  DECOMMISSIONING = 'Decommissioning',
  CONFIG_SUCCESS = 'Config Success',
  CONFIG_FAILED = 'Config Failed',
  DEPLOYMENT_FAILED = 'Deployment Failed',
  JOB_FAILED = 'Job Failed',
  CATEGORY_FAILED = 'Category Failed',
  PENDING_RESTART = 'Pending Restart'
}

export const DEFAULT_LOG_SOURCES_FOR_NEW_DEVICE = {
  sources: ['linux', 'windows'],
  input_configs: {},
  source_configs: {}
};
export const DEVICES_TABS = [
  {
    label: 'All Devices',
    path: '/devices',
    value: 0,
    ariaLabel: 'all-devices-tab',
    permissions: [PERMISSIONS.DEVICES_READ, PERMISSIONS.INTERNAL]
  },
  {
    label: 'Cloud Sources',
    path: '/devices/cloud-sources',
    value: 1,
    ariaLabel: 'cloud-sources-tab',
    permissions: [PERMISSIONS.SOURCES_READ, PERMISSIONS.INTERNAL]
  }
];

export const LIMA_SOURCES_TREND_BAR_SERIES: AgBarSeriesOptions[] = [
  {
    type: 'bar',
    xKey: 'date',
    xName: 'Date',
    yKey: 'count',
    yName: 'Events Per Day',
    fill: '#008ffb',
    tooltip: {
      renderer: (params) => {
        return `<div style="padding: 8px;">
          <span style="font-size: 12px;">${dayjs(params.datum.date).format(MONTH_DATE_FORMAT)}</span><br/>
          <span style="font-size: 12px;">Events: ${new Intl.NumberFormat('en-US').format(Math.round(params.datum.count))}</span>
        </div>`;
      }
    }
  }
];
